export const validPassword =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&#,.$($)$\-_/])[A-Za-zñ\d$@$!%*?&#.,$($)$\-_/]{8,}$/;

export const validEmail = /^(?![0-9]+@)[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$/gm;
export const validDocumentId = /^(?![0-9]+@)[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$/gm;

export const validateName = /^[a-zA-ZÀ-ÿ\s]+$/gm;
export const alphanumericPattern = /^[A-Za-z0-9]+$/;

export type TextFieldTypes =
  | 'date'
  | 'radio'
  | 'email'
  | 'number'
  | 'password'
  | 'search'
  | 'tel'
  | 'text'
  | 'url'
  | 'time'
  | 'week'
  | 'month'
  | 'textarea'
  | 'date-simple'
  | 'dial-code'
  | 'datetime-local';
